export default __webpack_public_path__ + "static/media/titleicon2.2c9c7dce.svg";